import React from "react";

import { getTranslation } from "../../../../helpers/getLanguage";
import CustomCheckbox from "../../../inputs/CustomCheckbox";

const HeaderTableIdeas = ({ sort, handleSortChange, handlePickedIdeasAll, selectedAll }) => {
  const SortableCell = ({ name, label }) => {
    const isActive = name === sort.field;

    return (
      <div className="flex align-center width-100">
        <span className={"ideas-row-text pointer" + (isActive ? " active" : "")} onClick={() => handleSortChange(name)}>
          {label}
        </span>
        {isActive && <div className={"sort-triangle-icon" + (sort.asc ? " asc" : "")}></div>}
      </div>
    );
  };

  return (
    <div className="ideas-container-header">
      <div className="ideas-row-header flex align-center">
        <div className="ideas-row-color-rating"></div>

        <div className="ideas-row-checkbox flex-center">
          <CustomCheckbox
            checked={selectedAll}
            handleChange={() => handlePickedIdeasAll()}
            customClass="ideas-checkbox"
          />
        </div>

        <div className="ideas-row-rating flex align-center padding-0">
          <SortableCell name="rating" label={getTranslation("SORTABLE_CELL_RATING")} />
        </div>

        <div className="ideas-row-name flex align-center">
          <SortableCell name="name" label={getTranslation("SORTABLE_CELL_IDEA_NAME")} />
        </div>

        <div className="ideas-row-method">
          <SortableCell name="method" label={getTranslation("SORTABLE_CELL_METHOD")} />
        </div>

        <div className="ideas-row-component flex align-center">
          <SortableCell name="component" label={getTranslation("SORTABLE_CELL_COMPONENT")} />
        </div>

        <div className="ideas-row-first-attribute flex align-center">
          <SortableCell name="firstAttribute" label={getTranslation("SORTABLE_CELL_ATTRIBUTE_ONE")} />
        </div>

        <div className="ideas-row-second-attribute flex align-center">
          <SortableCell name="secondAttribute" label={getTranslation("SORTABLE_CELL_ATTRIBUTE_TWO")} />
        </div>

        <div className="ideas-row-benefit flex align-center">
          <SortableCell name="benefits" label={getTranslation("SORTABLE_CELL_BENEFITS")} />
        </div>

        <div className="ideas-row-project flex align-center padding-0">
          <SortableCell name="project" label={getTranslation("SORTABLE_CELL_PROJECT")} />
        </div>

        <div className="ideas-row-created-by flex align-center padding-0">
          <span className="ideas-row-text">{getTranslation("SORTABLE_CELL_USER_OR_GROUP")}</span>
        </div>
      </div>
    </div>
  );
};

export default HeaderTableIdeas;
